



























































































































































































































































































































































































import ActionBar from '@/components/action-bar/action-bar.vue';
import PageLoader from '@/components/page-loader/page-loader.vue';
import { CONFIG } from '@/config';
import { dateService, normalize, stringService, httpService, notificationService, traceLogAccess } from '@/services';
import * as _ from 'lodash';
import * as moment from 'moment';
import { debounceTime, distinctUntilChanged, pluck, startWith } from 'rxjs/operators';
import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';
import { Http } from '@/decorators';
import { DAP_ROUTES } from '@/modules/dap/router';
import ProjectLoader from '@/modules/dap/components/project-loader/project-loader.vue';
import { Getter } from 'vuex-class';
import { AUTH_GET_TOKEN, AUTH_GET_USERNAME } from '@/store/modules/authentication/types';
import { Size, PageContextName } from '@/enums';
import { GET_LOADING } from '@/store/types';
import { IProject } from '@/modules/dap/interfaces';
import { AxiosError, AxiosResponse } from 'axios';
import { httpMixin } from '@/modules/neodash/mixins';
import KendoDropdown from '@/components/kendo-dropdown/kendo-dropdown.vue';
import { DapSpreadsheetFactory } from '@/modules/dap/services/dap-spreadsheet.factory';
import { DapSpreadsheetType } from '@/modules/dap/enums';
import DapProjectChangeFlowDate from '@/modules/dap/containers/dap-project-change-flow-date/dap-project-change-flow-date.vue';

@Component({
  subscriptions() {
    return {
      searchValue: this.$watchAsObservable('state.search.value').pipe(
        pluck('newValue'),
        debounceTime(400),
        distinctUntilChanged(),
        startWith('')
      )
    };
  },
  components: {
    ActionBar,
    PageLoader,
    ProjectLoader,
    KendoDropdown,
    DapProjectChangeFlowDate
  }
})
export default class DapSubmittedProjects extends Vue {
  @Getter(AUTH_GET_USERNAME)
  public userName: string;

  @Getter(GET_LOADING)
  isLoading: boolean;

  @Getter(AUTH_GET_TOKEN)
  public userToken: string;

  public state: any = {
    currentPage: 1,
    storeProjects: [],
    aovs: [],
    groups: [],
    dealers: [],
    regions: [],
    idProject: '',
    projectsSubmeted: [],
    search: {
      properties: [],
      property: 'name',
      value: ''
    },
    userAssociation: {},
    finishedProjectFlow: false,
    isConsolidate: false
  };

  public dataGeneratePDF: any = {
    idProject: null,
    aov: null,
    regiao: null,
    dealer: null,
    group: null
  };

  public sendForChangeFlowDate: boolean = false;
  public searchValue: string;
  public searchValue$: string;
  public projectTypeDataSource: any[] = ['DAP'];
  public activeType: number = 1;
  public searchInput: string = '';
  public idProject: number = 0;
  public open: boolean = false;
  public openFilterAOV: boolean = false;
  public openFilterGroup: boolean = false;

  public moment = moment;
  public Size = Size;
  public parseDateToString = dateService.parseDateToString;

  public get projectsLojas() {
    const perPage = 13;
    const projects = _(this.state.storeProjects)
      .filter((project: any) => {
        return _.size(this.searchValue)
          ? normalize(project.aov).includes(normalize(this.searchValue)) ||
              normalize(project.region).includes(normalize(this.searchValue)) ||
              normalize(project.dealerName).includes(normalize(this.searchValue)) ||
              normalize(project.dealerNumber).includes(normalize(this.searchValue)) ||
              normalize(project.city).includes(normalize(this.searchValue)) ||
              normalize(project.area).includes(normalize(this.searchValue)) ||
              normalize(project.state).includes(normalize(this.searchValue))
          : true;
      })
      .chunk(perPage)
      .value();

    const totalPages = projects.length;
    const page = this.state.currentPage > totalPages ? 1 : this.state.currentPage;
    const pages = [page];
    const pagesTotal = totalPages < 5 ? totalPages : 5;

    if (totalPages > 1) {
      let isLeft = true;
      while (pages.length < pagesTotal) {
        if (isLeft && pages[0] > 1) {
          pages.splice(0, 0, pages[0] - 1);
        } else if (pages[pages.length - 1] < totalPages) {
          pages.push(pages[pages.length - 1] + 1);
        }
        isLeft = !isLeft;
      }
    }

    return {
      page: page,
      perPage: perPage,
      offset: (page - 1) * perPage,
      total: this.state.storeProjects ? this.state.storeProjects.length : 0,
      totalPages,
      pages,
      data: projects[this.state.currentPage - 1]
    };
  }

  public openFilterReport() {
    this.dataGeneratePDF.dealer = null;
    this.dataGeneratePDF.aov = null;
    this.dataGeneratePDF.regiao = null;
    this.state.dealers = [];
    this.state.regions = [];

    this.open = true;
  }

  public openFilterReportAOV() {
    this.dataGeneratePDF.dealer = null;
    this.dataGeneratePDF.aov = null;
    this.dataGeneratePDF.regiao = null;
    this.state.dealers = [];
    this.state.regions = [];

    this.openFilterAOV = true;
  }

  public openFilterReportGroup() {
    this.dataGeneratePDF.dealer = null;
    this.dataGeneratePDF.aov = null;
    this.dataGeneratePDF.regiao = null;
    this.dataGeneratePDF.group = null;
    this.state.dealers = [];

    this.state.groups = _(this.state.storeProjects)
      .map((store: any) => ({
        text: store.groupName,
        value: store.idGroup
      }))
      .uniqBy((d: any) => d.value)
      .value();

    this.openFilterGroup = true;
  }

  public cancelModal() {
    this.open = false;
    this.openFilterAOV = false;
    this.openFilterGroup = false;
  }

  public reloadProjects(object: any) {
    this.getProjects();
    this.sendForChangeFlowDate = false;
  }

  public get getAOVFilter() {
    return _(this.state.storeProjects)
      .map((store: any) => ({
        text: store.aov,
        value: store.idAOV
      }))
      .uniqBy((d: any) => d.value)
      .value();
  }

  public get projectsView() {
    return _(this.state.projectsSubmeted)
      .filter((p: IProject) => p.idProjectType === this.activeType)
      .filter((p: IProject) =>
        _.size(this.searchInput)
          ? stringService.normalize(p.name).includes(stringService.normalize(this.searchInput))
          : true
      )
      .orderBy((p: IProject) => -p.id)
      .value();
  }

  public goBack() {
    this.$router.push({
      name: 'home'
    });
  }

  public goToProject(project: any) {
    this.$router.push({
      name: DAP_ROUTES.SUBMITTED_PROJECT_RETAIL,
      params: {
        projectId: String(project.id),
        storeId: String(project.dealerNumber)
      }
    });
  }

  public selectProject(projectId: number) {
    this.state.idProject = projectId;
    this.state.finishedProjectFlow = _(this.state.projectsSubmeted)
      .filter((p: any) => p.id === this.state.idProject)
      .map((d: any) => d.finishedProjectFlow)
      .value()[0];

    this.state.isConsolidate = _(this.state.projectsSubmeted)
      .filter((p: any) => p.id === this.state.idProject)
      .map((d: any) => d.isConsolidate)
      .value()[0];

    this.state.storeProjects = _(this.state.projectsSubmeted.filter((p: any) => p.id === this.state.idProject))
      .map((d: any) =>
        _.map(d.storeProjects, (store: any) => ({
          id: d.id,
          name: d.name,
          dealerName: store.name,
          dealerNumber: store.dealerNumber,
          confirmed: store.confirmed,
          state: store.state,
          city: store.city,
          dateForResponseStart: new Date(d.dateForResponseStart),
          dateForResponseEnd: new Date(d.dateForResponseEnd),
          region: store.region,
          aov: store.aov,
          area: store.area,
          idAOV: store.idAov,
          idRegiao: store.idLocaleAgg,
          idGroup: store.idEconomicGroup,
          groupName: store.groupName
        }))
      )
      .flatten()
      .orderBy((d: any) => d.dealerName)
      .orderBy((d: any) => -d.id)
      .value();

    this.dataGeneratePDF = {
      idProject: null,
      aov: null,
      regiao: null,
      dealer: null,
      reportType: null,
      typeExtensionReport: null
    };

    this.dataGeneratePDF.idProject = projectId;

    this.state.aovs = _(this.state.storeProjects)
      .map((store: any) => ({
        text: store.aov,
        value: store.idAOV
      }))
      .uniqBy((d: any) => d.value)
      .value();
  }

  public getRegions(aov) {
    this.dataGeneratePDF.aov = aov;
    this.state.dealers = [];

    this.state.regions = _(this.state.storeProjects)
      .filter((store: any) => store.idAOV === this.dataGeneratePDF.aov.value)
      .map((store: any) => ({
        text: store.region,
        value: store.idRegiao
      }))
      .uniqBy((d: any) => d.value)
      .value();
  }

  public getDealers(region) {
    this.dataGeneratePDF.regiao = region;
    this.dataGeneratePDF.dealer = null;

    this.state.dealers = _(this.state.storeProjects)
      .filter((store: any) => store.idRegiao == this.dataGeneratePDF.regiao.value)
      .map((store: any) => ({
        text: store.dealerName,
        value: store.dealerNumber
      }))
      .uniqBy((d: any) => d.value)
      .value();
  }

  public getDealersGroup(group) {
    this.dataGeneratePDF.group = group;
    this.dataGeneratePDF.dealer = null;

    this.state.dealers = _(this.state.storeProjects)
      .filter((store: any) => store.idGroup == this.dataGeneratePDF.group.value)
      .map((store: any) => ({
        text: store.dealerName,
        value: store.dealerNumber
      }))
      .uniqBy((d: any) => d.value)
      .value();
  }

  public setDealer(dealer) {
    this.dataGeneratePDF.dealer = dealer;
  }

  public getPDF(parameters: any) {
    const parametersFormat = {
      idProject: parameters.idProject,
      cdAOV: parameters.aov ? parameters.aov.value : null,
      cdRegiao: parameters.regiao ? parameters.regiao.value : null,
      cdDealer: parameters.dealer ? parameters.dealer.value : null,
      cdGroup: parameters.group ? parameters.group.value : null,
      reportType: parameters.reportType,
      typeExtensionReport: parameters.typeExtensionReport
    };

    httpService.httpBlob
      .post(`${CONFIG.URL.NEODASH_API}/api/dap/approval/bookDap/pdf`, parametersFormat)
      .then((res: AxiosResponse) => {
        const blob = new Blob([res.data], {
          type: 'application/pdf'
        });

        if (this.dataGeneratePDF.reportType === 1) {
          kendo.saveAs({
            dataURI: window.URL.createObjectURL(blob),
            fileName: `Relatorio_OAP_` + moment(new Date()).format('YYYY_MM_DD-hh_mm_ss') + `.pdf`
          });
        } else {
          kendo.saveAs({
            dataURI: window.URL.createObjectURL(blob),
            fileName: `Relatorio_OAP_SUMMARY` + moment(new Date()).format('YYYY_MM_DD-hh_mm_ss') + `.pdf`
          });
        }
      })
      .catch((err: AxiosError) => {
        console.log('Error', err);
      });
  }

  public getPDF_OAP() {
    this.cancelModal();
    this.dataGeneratePDF.reportType = 1;
    this.dataGeneratePDF.typeExtensionReport = 2;
    this.getPDF(this.dataGeneratePDF);
  }

  public getPDF_OAP_SUMARIO() {
    this.dataGeneratePDF.reportType = 2;
    this.dataGeneratePDF.typeExtensionReport = 2;
    this.getPDF(this.dataGeneratePDF);
  }

  public getPDF_OAP_AOV() {
    this.cancelModal();
    this.dataGeneratePDF.reportType = 3;
    this.dataGeneratePDF.typeExtensionReport = 2;
    this.getPDF(this.dataGeneratePDF);
  }

  public getPDF_OAP_GROUP() {
    this.cancelModal();
    this.dataGeneratePDF.reportType = 4;
    this.dataGeneratePDF.typeExtensionReport = 2;
    this.getPDF(this.dataGeneratePDF);
  }

  public mounted() {
    traceLogAccess.generationTracking(PageContextName.dapFlowAproval);
    this.getProjects();
  }

  @Http('get', `${CONFIG.URL.NEODASH_API}/api/dap/approval/submited/active/2`)
  @Http('get', `${CONFIG.URL.NEODASH_API}/api/dap/approval/user/association/`)
  public getProjects(params?: any, error?, data?) {
    this.state.projectsSubmeted = data[0];
    this.state.userAssociation = data[1];
  }

  public consolidateApprovalFlow() {
    httpService.http
      .post(`${CONFIG.URL.NEODASH_API}/api/dap/approval/${this.state.idProject}/consolidateApprovalFlowResults`)
      .then((res: AxiosResponse) => {
        if (res.status === 200) {
          notificationService.sendToast({
            status: 1,
            type: 'success',
            message: 'Fluxo Consolidado com sucesso!'
          });

          setTimeout(() => {
            this.$router.push({
              name: DAP_ROUTES.SUBMITTED_PROJECTS_RETAIL
            });
          }, 100);
        }
      });
  }

  public saveAsExcelFlow() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/dap/approval/${this.state.idProject}/approvalFlowValuesConfigRetail`)
      .then((res: AxiosResponse) => {
        let unbundled: any[] = _(res.data)
          .map((d: any) =>
            _(d.forecast_RapFamilyResultsPerMonth)
              .map((r: any) => ({
                consolidate: _(d.consolidate_RapFamilyResultsPerMonth)
                  .groupBy(function(d) {
                    return d.year;
                  })
                  .map((c: any) => ({
                    value: _(c)
                      .filter((f: any) => f.idFamily === r.idFamily)
                      .map((m: any) => m.value)
                      .sum(),
                    description: c[0].year
                  }))
                  .value(),
                value: r.value,
                idFamily: r.idFamily,
                familyName: r.familyName,
                year: r.year,
                aov: d.aov,
                approvalHierarchy: d.approvalHierarchyRetail ? d.approvalHierarchyRetail : 0,
                approvalHierarchyName: d.approvalHierarchyRetail ? d.approvalHierarchyName : 'DAP',
                city: d.city,
                dateOpening: d.dateOpening,
                dealerName: d.dealerName,
                dealerNumber: d.dealerNumber,
                groupName: d.groupName,
                idAov: d.idAov,
                idDealer: d.idDealer,
                markedAreaName: d.markedAreaName,
                permitAlter: d.permitAlter,
                region: d.region,
                regionale: d.regionale,
                idStoreMatrixBefore: d.idStoreMatrixBefore,
                state: d.state,
                idEntity: r.idEntity,

                description: d.description,
                tdbCompleted: d.tdbCompleted,
                regioesCompleted: d.regioesCompleted,
                aovCompleted: d.aovCompleted,
                comiteCompleted: d.comiteCompleted
              }))
              .value()
          )
          .flattenDeep()
          .value();

        let grouped: any[] = _(unbundled)
          .groupBy(function(d) {
            return d.dealerNumber + '-' + d.idFamily;
          })
          .map((d: any) => ({
            keyValue: d[0].dealerNumber + '-' + d[0].idFamily,
            dealerNumber: d[0].dealerNumber,
            dealerName: d[0].dealerName,
            idFamily: d[0].idFamily,
            familyName: d[0].familyName,
            aov: d[0].aov,
            city: d[0].city,
            dateOpening: d[0].dateOpening,
            groupName: d[0].groupName,
            idAov: d[0].idAov,
            idDealer: d[0].idDealer,
            markedAreaName: d[0].markedAreaName,
            region: d[0].region,
            regionale: d[0].regionale,
            idStoreMatrixBefore: d[0].idStoreMatrixBefore,
            state: d[0].state,
            consolidate: d[0].consolidate,
            description: d[0].description,

            tdbCompleted: d.some(function(f) {
              return f.tdbCompleted === true;
            })
              ? 'Sim'
              : 'Não',

            regioesCompleted: d.some(function(f) {
              return f.regioesCompleted === true;
            })
              ? 'Sim'
              : 'Não',

            aovCompleted: d.some(function(f) {
              return f.aovCompleted === true;
            })
              ? 'Sim'
              : 'Não',

            comiteCompleted: d.some(function(f) {
              return f.comiteCompleted === true;
            })
              ? 'Sim'
              : 'Não',

            forecast_year_now: _(d)
              .filter((f: any) =>
                  _.some(d[0].consolidate, (s: any) => { return s.description == f.year; }) && f.approvalHierarchy == 4)
              .groupBy(function(g) { return g.year + '-' + g.approvalHierarchy; })
              .map((m: any) => ({
                value: _(m)
                  .map((s: any) => s.value)
                  .sum(),
                year: m[0].year,
                approvalHierarchy: m[0].approvalHierarchy,
                approvalHierarchyName: m[0].approvalHierarchyName
              }))
              .orderBy((m: any) => m.year)
              .orderBy((m: any) => m.approvalHierarchy)
              .value(),

              forecast_RapFamilyResultsPerMonth: _(d)
                  .filter((f: any) => _.some(d[0].consolidate, (s: any) => { return s.description == f.year; }))
                  .groupBy(function(g) { return g.year + '-' + g.approvalHierarchy; })
                  .map((m: any) => ({
                      value: _(m)
                          .map((s: any) => s.value)
                          .sum(),
                      year: m[0].year,
                      approvalHierarchy: m[0].approvalHierarchy,
                      approvalHierarchyName: m[0].approvalHierarchyName
                  }))
                  .orderBy((m: any) => m.year)
                  .orderBy((m: any) => m.approvalHierarchy)
                  .value()
          }))
          .orderBy((m: any) => m.familyName)
          .orderBy((m: any) => m.dealerNumber)
          .value();

        DapSpreadsheetFactory.get(DapSpreadsheetType.AprovationFlowRetail, grouped)
          .create()
          .saveAsExcel();
      })
      .catch((err: AxiosError) => {
        console.log('Error', err);
      });
  }

  public saveAsExcelConsolidateFlow() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/dap/approval/${this.state.idProject}/finalApprovalFlowResults`)
      .then((res: AxiosResponse) => {
        let unbundled: any[] = _(res.data)
          .map((d: any) =>
            _(d.forecast_RapFamilyResultsPerMonth)
              .map((r: any) => ({
                consolidate: _(d.consolidate_RapFamilyResultsPerMonth)
                  .groupBy(function(d) {
                    return d.year;
                  })
                  .map((c: any) => ({
                    value: _(c)
                      .filter((f: any) => f.idFamily === r.idFamily)
                      .map((m: any) => m.value)
                      .sum(),
                    description: c[0].year
                  }))
                  .value(),
                value: r.value,
                idFamily: r.idFamily,
                familyName: r.familyName,
                year: r.year,
                aov: d.aov,
                approvalHierarchy: d.approvalHierarchyRetail ? d.approvalHierarchyRetail : 0,
                approvalHierarchyName: d.approvalHierarchyRetail ? d.approvalHierarchyName : 'DAP',
                city: d.city,
                dateOpening: d.dateOpening,
                dealerName: d.dealerName,
                dealerNumber: d.dealerNumber,
                groupName: d.groupName,
                idAov: d.idAov,
                idDealer: d.idDealer,
                markedAreaName: d.markedAreaName,
                permitAlter: d.permitAlter,
                region: d.region,
                description: d.description,
                regionale: d.regionale,
                idStoreMatrixBefore: d.idStoreMatrixBefore,
                state: d.state,
                idEntity: r.idEntity,
                newIndexForecast: _(d.newIndexForecast_RapFamilyResultsPerMonth)
                  .filter((f: any) => f.idFamily == r.idFamily)
                  .map((c: any) => ({
                    familyName: c.familyName,
                    idFamily: c.idFamily,
                    indexValue: c.indexValue,
                    month: c.month,
                    monthName: c.monthName,
                    year: c.year,
                    value: c.value
                  }))
                  .value(),

                tdbCompleted: d.tdbCompleted,
                regioesCompleted: d.regioesCompleted,
                aovCompleted: d.aovCompleted,
                comiteCompleted: d.comiteCompleted
              }))
              .value()
          )
          .flattenDeep()
          .value();

        let grouped: any[] = _(unbundled)
          .groupBy(function(d) {
            return d.dealerNumber + '-' + d.idFamily;
          })
          .map((d: any) => ({
            keyValue: d[0].dealerNumber + '-' + d[0].idFamily,
            dealerNumber: d[0].dealerNumber,
            dealerName: d[0].dealerName,
            idFamily: d[0].idFamily,
            familyName: d[0].familyName,
            aov: d[0].aov,
            city: d[0].city,
            dateOpening: d[0].dateOpening,
            groupName: d[0].groupName,
            idAov: d[0].idAov,
            idDealer: d[0].idDealer,
            markedAreaName: d[0].markedAreaName,
            region: d[0].region,
            regionale: d[0].regionale,
            idStoreMatrixBefore: d[0].idStoreMatrixBefore,
            state: d[0].state,
            consolidate: d[0].consolidate,
            monthlyAnnualPlan: d[0].newIndexForecast,
            monthlyAnnualPlanNormalization: d[0].newIndexForecast,

            tdbCompleted: d.some(function(f) {
              return f.tdbCompleted === true;
            })
              ? 'Sim'
              : 'Não',

            regioesCompleted: d.some(function(f) {
              return f.regioesCompleted === true;
            })
              ? 'Sim'
              : 'Não',

            aovCompleted: d.some(function(f) {
              return f.aovCompleted === true;
            })
              ? 'Sim'
              : 'Não',

            comiteCompleted: d.some(function(f) {
              return f.comiteCompleted === true;
            })
              ? 'Sim'
              : 'Não',

            forecast_year_now: _(d)
              .filter(
                (f: any) =>
                  _.some(d[0].consolidate, (s: any) => {
                    return s.description == f.year;
                  }) && f.approvalHierarchy == 4
              )
              .groupBy(function(g) {
                return g.year + '-' + g.approvalHierarchy;
              })
              .map((m: any) => ({
                value: _(m)
                  .map((s: any) => s.value)
                  .sum(),
                year: m[0].year,
                approvalHierarchy: m[0].approvalHierarchy,
                approvalHierarchyName: m[0].approvalHierarchyName
              }))
              .orderBy((m: any) => m.year)
              .orderBy((m: any) => m.approvalHierarchy)
              .value(),

            forecast_Description: _(d)
              .filter((f: any) => !_.some(d[0].consolidate, (s: any) => { return s.description == f.year; }))
              .groupBy(function(g) { return g.approvalHierarchy; })
              .map((m: any) => ({
                description: m[0].description,
                approvalHierarchy: m[0].approvalHierarchy,
                approvalHierarchyName: m[0].approvalHierarchyName
              }))
              .orderBy((m: any) => m.year)
              .orderBy((m: any) => m.approvalHierarchy)
              .value(),

            forecast_RapFamilyResultsPerMonth: _(d)
              .filter((f: any) => _.some(d[0].consolidate, (s: any) => { return s.description == f.year; }))
              .groupBy(function(g) { return g.year + '-' + g.approvalHierarchy; })
              .map((m: any) => ({
                value: _(m)
                  .map((s: any) => s.value)
                  .sum(),
                year: m[0].year,
                approvalHierarchy: m[0].approvalHierarchy,
                approvalHierarchyName: m[0].approvalHierarchyName
              }))
              .orderBy((m: any) => m.year)
              .orderBy((m: any) => m.approvalHierarchy)
              .value()
          }))
          .orderBy((m: any) => m.familyName)
          .orderBy((m: any) => m.dealerNumber)
          .value();

        DapSpreadsheetFactory.get(DapSpreadsheetType.AprovationFlowRetailConsolidate, grouped)
          .create()
          .saveAsExcel();
      })
      .catch((err: AxiosError) => {
        console.log('Error', err);
      });
  }

  public goToChangeFlowDate(projectId: number, projectName: string) {
    this.state.idProject = projectId;
    this.state.projectName = projectName;
    this.sendForChangeFlowDate = true;
  }
}
